import React, {FC} from 'react'
import {inject, observer} from 'mobx-react'
import {useEffectOnce} from 'react-use';
import classnames from 'classnames'

import {Progress, Row, Col} from 'antd'

import StylesType from '@/types/StylesType';
import {BaseStoreProps} from '@/stores/base';
import FileOpearNav from './FileOpearNav'
import FileOpearButtons from './FileOpearButtons'
import FileOpearTable from './FileOpearTable'
import Icon from '@/components/Icon'

import './style/index.less'
import {SelectIndexType} from "@/stores/base/UploadStore";

export interface Nav {
  title: string;
  icon: string;
  key: SelectIndexType
}

const UploadFile: FC<BaseStoreProps & StylesType> = inject('BaseStore')(observer(props => {
  const {prefixCls = 'gc_'} = props
  let {UploadStore} = props.BaseStore
  const {selectIndex,
    changeSelectIndex,
    getFile, uploadBegin,
    fileList, getFileUploading,
    fileHistoryList,
    clearHistory,
    used_space,
    all_space,
    clickUpload,
    getDeleteId,
  } = UploadStore
  const navList: Nav[] = [
    {
      title: '全部文件',
      icon: 'iconquanbuwenjian',
      key: 1
    }, {
      title: '正在上传',
      icon: 'iconshangchuanwenjian1',
      key: 2
    }, {
      title: '上传记录',
      icon: 'iconshangchuanjilu',
      key: 3
    },
  ]
  useEffectOnce(() => {
    UploadStore.init()
  })
  const getSize = (num: number): string => {
    let sizeG:string = String(num / (1024 * 1024 * 1024))
    let sizeM:string = String(num / (1024 * 1024))

    if (parseInt(sizeG, 0) > 0) {
      return Math.floor(num / 1024 / 1024 / 1024 * 100) / 100 + 'G'
    }
    if (parseInt(sizeM, 0) > 0) {
      return Math.floor(num / 1024 / 1024 * 100) / 100 + 'M'
    }
    return Math.floor(num / 1024 * 100) / 100 + 'KB'
  }


  return (
    <div className={classnames(prefixCls + 'z_uploadFile', {[prefixCls + 'showModal']: UploadStore.showModal})}>
      {/*弹框按钮*/}
      <div className={classnames('closeBtn')} onClick={() => UploadStore.changeModalShow(false)}><Icon type={'iconclose'}/></div>
      {/*左侧*/}
      <div className={classnames('z_uploadFile_left')}>
        <div className='z_uploadFile_left_top'>
          <Row>
            <Col>
              <div className='title'>文件管理<span>{getSize(used_space)}/{getSize(all_space)}</span></div>
            </Col>
            <Col className={classnames('tsfY3')}>
              <Progress
                percent={(used_space/all_space)* 100}
                strokeColor='#3796FF'
                showInfo={false}
                strokeWidth={6}
              ></Progress>
            </Col>
          </Row>
        </div>
        <FileOpearNav seletIndex={selectIndex} changeSelectIndex={changeSelectIndex} navList={navList}></FileOpearNav>
      </div>
      {/*右侧*/}
      <div className='z_uploadFile_right'>
        <FileOpearButtons uploadBegin={uploadBegin}
                          getFile={getFile}
                          clearHistory={clearHistory}
                          selectIndex={selectIndex}
                          clickUpload={clickUpload}
        ></FileOpearButtons>
        <FileOpearTable selectIndex={selectIndex} fileList={fileList}
                        fileHistoryList={fileHistoryList}
                        getDeleteId={getDeleteId}
                        fileUploading={getFileUploading}
        />
      </div>
    </div>
  )
}))

export default UploadFile
